module.exports = __webpack_public_path__ + "static/img/10057L_1_2_R_20221107_LC.08c72cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/10057L_1_2_R_20221107_LC.png
// module id = bCx9
// module chunks = 0